module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogIzFlODBmZjsNCiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOw0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPHBhdGggaWQ9Iua3u+WKoOmAiemhuSIgY2xhc3M9ImNscy0xIiBkPSJNNzk0LDYyOWgtNnY2aC0ydi02aC02di0yaDZ2LTZoMnY2aDZ2MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03ODAgLTYyMSkiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/添加选项.svg
// module id = Upyx
// module chunks = 0